import React from "react";
import TableGlobal from "../Table/TableGlobal";

const ContentGlobal = ({ items }) => {
  return (
    <div>
      <TableGlobal items={items} />
    </div>
  );
};

export default ContentGlobal;
